module.exports = __webpack_public_path__ + "img/Z81_03.43571834.jpg";